// extracted by mini-css-extract-plugin
module.exports = {"togglerLabel":"SimpleToggler_togglerLabel__1dcxY"};